import { PluginKey } from 'prosemirror-state';
import { ySyncPluginKey, yUndoPluginKey } from 'y-prosemirror';

import { AddMenuPluginKey } from '@lyearn/lygo-blocks/src/plugins/AddMenu/consts';
import { blockMenuKey } from '@lyearn/lygo-blocks/src/plugins/BlockMenu/utils/utils';
import { blockMenuButtonkey } from '@lyearn/lygo-blocks/src/plugins/BlockMenuButton';
import { selectionMenuKey } from '@lyearn/lygo-blocks/src/plugins/SelectionMenu/getSelectionPlugins';

import { editorStatskey } from './editorStatsPlugin';
import { nodePerformanceMapKey } from './nodePerformanceMapPlugin';
import { portalKey } from './portalKeyPlugin';

export const colorHighlighterKey = new PluginKey('color-highlighter-plugin');

export const viewerAllowedPluginKeys = [colorHighlighterKey, ySyncPluginKey, nodePerformanceMapKey];
export const viewerAllowedPluginKeysLocalized = [
  editorStatskey,
  blockMenuButtonkey,
  blockMenuKey,
  portalKey,
  AddMenuPluginKey,
  selectionMenuKey,
  yUndoPluginKey,
];

export const getRequiredPlugin = (isLocalizedContent?: boolean) => {
  if (isLocalizedContent) {
    return [...viewerAllowedPluginKeys, ...viewerAllowedPluginKeysLocalized];
  }
  return viewerAllowedPluginKeys;
};
